import { cls } from "@kikoff/utils/src/string";

import SignupButton from "@component/landing/kikoff_card/signup_button";
import WaitlistButton from "@component/landing/kikoff_card/waitlist_button";

import { Flow } from "../container";

import styles from "./styles.module.scss";

function Footer({ flow }: { flow: Flow }) {
  let footerText;

  if (flow === "waitlist") {
    footerText =
      "Get notified when it’s time to sign up for the Kikoff Secured Credit Card";
  } else if (flow === "signup") {
    footerText = "Sign up for the Kikoff Secured Credit Card";
  }

  return (
    <section className={styles["get-notified-section"]}>
      <div className={styles["alignment-wrapper"]}>
        <div
          className={cls(
            "text:heading-1",
            styles["get-notified-title"],
            "my-6"
          )}
        >
          {footerText}
        </div>
        {flow === "waitlist" && <WaitlistButton />}
        {flow === "signup" && <SignupButton />}
      </div>
    </section>
  );
}

export default Footer;
